module.exports = __webpack_public_path__ + "static/img/home_img_4.bd96e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img_4.png
// module id = LG3u
// module chunks = 0